/* tslint:disable */
/* eslint-disable */
export enum VpnConnectionMode {
  ActivateRouteOnDemand = 'ACTIVATE_ROUTE_ON_DEMAND',
  ActivateAllRoutesOnDemand = 'ACTIVATE_ALL_ROUTES_ON_DEMAND',
  ActivateAllRoutesOnConnect = 'ACTIVATE_ALL_ROUTES_ON_CONNECT'
}
